import { styled, Tooltip, TooltipProps, tooltipClasses } from '@mui/material';

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
	<Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: 'white',
		color: 'rgba(0, 0, 0, 0.87)',
		maxWidth: 1000,
		fontSize: theme.typography.pxToRem(12),
		border: '0.1px solid #dadde9',
	},
}));

export default HtmlTooltip;
